/**
 * 装车台效率排名（OPC）— POST /api/produce/kanban/loading-bay-efficiency-rank
 */
import request from '@/router/axios'

const API = '/api/produce/kanban/loading-bay-efficiency-rank'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

export function fetchLoadingBayEfficiencyRank(params = {}) {
  return request({
    url: API,
    method: 'post',
    data: params
  }).then(unwrap)
}
